var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6152 6.39094C15.4267 3.53708 12.642 1.67487 9.55055 1.66661C6.21872 1.64907 3.25614 3.78322 2.21754 6.94908C1.17894 10.115 2.30159 13.5893 4.99632 15.5488C7.69106 17.5084 11.3423 17.5055 14.0339 15.5416L16.4339 17.9416C16.6779 18.1853 17.0732 18.1853 17.3172 17.9416C17.5609 17.6976 17.5609 17.3023 17.3172 17.0583L14.9922 14.7333C17.164 12.5331 17.8037 9.24481 16.6152 6.39094ZM15.5009 11.8074C14.503 14.2121 12.1541 15.7783 9.55055 15.7749V15.7416C6.01698 15.7371 3.14843 12.8834 3.12555 9.34995C3.12218 6.74639 4.68838 4.39748 7.0931 3.39959C9.49783 2.40169 12.2669 2.95157 14.1079 4.79256C15.9489 6.63356 16.4988 9.40267 15.5009 11.8074Z",
    fill: "#686868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass);
export default __webpack_public_path__ + "static/media/glass.f2883960b31aa8af65e087750ff3fe06.svg";
export { ForwardRef as ReactComponent };